import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "tw-px-20px tw-mb-10px"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src", "onClick"];
var _hoisted_4 = {
  "class": "tw-grid tw-grid-cols-12 tw-h-[calc(100%-62px)] sm:tw-h-full tw-p-0 tw-relative"
};
var _hoisted_5 = {
  key: 0,
  "class": "tw-col-span-12 lg:tw-col-span-4 xl:tw-col-span-3 tw-p-0 md:tw-px-20px sm:tw-pt-20px sm:tw-mx-20px lg:tw-mx-0"
};
var _hoisted_6 = {
  "class": "lg:tw-ml-10px md:tw-mb-20px lg:tw-mt-40px"
};
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = ["src"];
var _hoisted_9 = ["src", "onClick"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
  "class": "tw-block tw-col-span-12 lg:tw-col-span-8 xl:tw-col-span-9 tw-p-0"
};
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["data-lat", "data-lng"];
var _hoisted_14 = {
  key: 1,
  id: "around-me-container",
  "class": "controls tw-w-full tw-px-15px tw-flex tw-flex-col tw-fixed tw-bottom-[75px] tw-z-[999999]"
};
var _hoisted_15 = {
  id: "radiusLabel",
  "class": "tw-mb-5px tw-px-20px tw-flex tw-justify-center"
};
var _hoisted_16 = {
  "class": "tw-bg-white tw-text tw-px-10px tw-py-5px tw-font-medium lbl tw-text-center"
};
var _hoisted_17 = {
  "class": "tw-bg-transparent tw-py-10px tw-text tw-relative tw-block tw-overflow-hidden tw-grow tw-px-20px"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_autocomplete = _resolveComponent("base-autocomplete");
  var _component_base_button = _resolveComponent("base-button");
  var _component_base_alert = _resolveComponent("base-alert");
  var _component_base_bt_modal = _resolveComponent("base-bt-modal");
  return _openBlock(), _createBlock(_component_base_bt_modal, {
    id: "map-modal",
    "data-cy": "map-modal",
    size: "modal-full",
    "show-modal": _ctx.openMapModal,
    "custom-modal-classes": "sm:max-lg:tw-h-full !tw-max-w-full",
    "custom-backdrop-classes": "tw-no-scrollbar",
    "custom-modal-body-classes": "!tw-p-0 tw-relative tw-h-full",
    "custom-modal-content-classes": "!tw-p-0 tw-flex tw-flex-col md:max-lg:tw-h-full",
    "custom-modal-header-classes": [_ctx.headerClasses, 'tw-px-20px'],
    "header-title": !_ctx.aroundMe ? _ctx.labels.drawOnMap : _ctx.labels.closeOnYou,
    "full-height": true,
    "close-on-click-out": false,
    onClosed: _ctx.hideMapModal
  }, {
    body: _withCtx(function () {
      return [_ctx.isSmall ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_base_autocomplete, {
        id: "map-modal_autocomplete_places",
        "data-cy": "map-modal_autocomplete_places",
        modelValue: _ctx.currentAddress,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.currentAddress = $event;
        }),
        label: _ctx.labels.searchPlace,
        "on-input-change-cb": _ctx.onInputChangeCb,
        "on-option-selected-cb": _ctx.optionSelectedCb,
        "disable-cb": _ctx.autocompleteDisabled,
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.autocompleteDisabled = false;
        })
      }, {
        lefticon: _withCtx(function () {
          return [_createElementVNode("img", {
            src: "".concat(_ctx.cdn, "/_ui/img/Ico/zoom-blue.svg"),
            alt: "cerca",
            "class": "text-input-icon left sm"
          }, null, 8 /* PROPS */, _hoisted_2)];
        }),
        righticon: _withCtx(function (_ref) {
          var handleClean = _ref.handleClean;
          return [_ctx.currentAddress && _ctx.currentAddress.label.length > 0 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: "".concat(_ctx.cdn, "/_ui/img/Ico/close.svg"),
            "class": "text-input-icon right sm",
            alt: "Clean Icon",
            onClick: _withModifiers(function ($event) {
              handleClean();
            }, ["stop"])
          }, null, 8 /* PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "label", "on-input-change-cb", "on-option-selected-cb", "disable-cb"])])) : _createCommentVNode("v-if", true), _createCommentVNode(" 62px is the height of the autocomplete "), _createElementVNode("div", _hoisted_4, [!_ctx.isSmall ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_base_button, {
        type: "button",
        "class": "tw-absolute sm:max-lg:tw-right-0 lg:-tw-left-[7px] tw-top-10px tw-bg-transparent",
        "data-cy": "close-map-modal-btn",
        "icon-name": "close.svg",
        "icon-class": "icon-md",
        onClick: _withModifiers(_ctx.closeMapModal, ["stop", "prevent"])
      }, null, 8 /* PROPS */, ["onClick"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h3", {
        "class": "tw-text-w-black tw-text-22",
        innerHTML: _ctx.labels.drawOnMap
      }, null, 8 /* PROPS */, _hoisted_7), _createVNode(_component_base_autocomplete, {
        id: "map-modal_autocomplete_places_desktop",
        "data-cy": "map-modal_autocomplete_places_desktop",
        modelValue: _ctx.currentAddress,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.currentAddress = $event;
        }),
        label: _ctx.labels.searchPlace,
        "on-input-change-cb": _ctx.onInputChangeCb,
        "on-option-selected-cb": _ctx.optionSelectedCb,
        "disable-cb": _ctx.autocompleteDisabled,
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.autocompleteDisabled = false;
        })
      }, {
        lefticon: _withCtx(function () {
          return [_createElementVNode("img", {
            src: "".concat(_ctx.cdn, "/_ui/img/Ico/zoom-blue.svg"),
            alt: "cerca",
            "class": "text-input-icon left sm"
          }, null, 8 /* PROPS */, _hoisted_8)];
        }),
        righticon: _withCtx(function (_ref2) {
          var handleClean = _ref2.handleClean;
          return [_ctx.currentAddress && _ctx.currentAddress.label.length > 0 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: "".concat(_ctx.cdn, "/_ui/img/Ico/close.svg"),
            "class": "text-input-icon right sm",
            alt: "Clean Icon",
            onClick: _withModifiers(function ($event) {
              handleClean();
            }, ["stop"])
          }, null, 8 /* PROPS */, _hoisted_9)) : _createCommentVNode("v-if", true)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "label", "on-input-change-cb", "on-option-selected-cb", "disable-cb"])]), _ctx.browserSupportGeolocation() && !_ctx.aroundMe ? (_openBlock(), _createBlock(_component_base_button, {
        key: 0,
        id: "desktopGpsButtonRow",
        "btn-class": "btn-link tw-text-w-black tw-no-underline tw-pl-10px tw-pt-5px",
        "icon-class": "icon-md tw-mr-10px",
        "icon-name": "geolocation.svg",
        onClick: _withModifiers(_ctx.getPosition, ["stop"])
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("span", {
            "class": "tw-font-regular",
            innerHTML: _ctx.labels.useMyPosition
          }, null, 8 /* PROPS */, _hoisted_10)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        id: "map-container",
        "class": _normalizeClass(["map-container tw-h-full tw-w-full tw-bg-white tw-p-0 tw-relative", {
          'map-error': _ctx.mapError
        }])
      }, [_ctx.browserSupportGeolocation() && !_ctx.aroundMe && !_ctx.isDesktopMode ? (_openBlock(), _createBlock(_component_base_button, {
        key: 0,
        id: "gpsButton",
        "class": "tw-fixed tw-size-10 tw-z-[1030] tw-rounded-full tw-p-0 tw-bg-white tw-min-w-0 tw-right-10px tw-bottom-[80px] sm:tw-top-[140px] md:max-lg:tw-top-[200px]",
        "icon-class": "icon-lg",
        "icon-name": "gps-blue.svg",
        onClick: _withModifiers(_ctx.getPosition, ["stop"])
      }, null, 8 /* PROPS */, ["onClick"])) : _createCommentVNode("v-if", true), _ctx.mapError || _ctx.mapWarning ? (_openBlock(), _createBlock(_component_base_alert, {
        key: 1,
        id: "map-error",
        "alrt-class": "tw-alert-w-danger tw-text-center tw-my-10px tw-border tw-border-w-danger tw-rounded tw-absolute tw-z-10 tw-left-1/2 -tw-translate-x-1/2"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("p", {
            "class": "tw-m-0",
            innerHTML: _ctx.labelText
          }, null, 8 /* PROPS */, _hoisted_12)];
        }),
        _: 1 /* STABLE */
      })) : _createCommentVNode("v-if", true), _createElementVNode("div", {
        id: "leaflet-map-container",
        ref: "mapPlaceholder",
        "class": _normalizeClass(["map polygon-draw tw-bg-no-repeat tw-bg-center tw-bg-cover tw-z-0 lg:tw-rounded-r", {
          'min-h-desktop sm:max-lg:tw-min-h-[68vh] lg:tw-min-h-[86vh]': _ctx.isDesktop
        }]),
        "data-layers": "",
        "data-drawing-manager": "POLYGON",
        "data-lat": _ctx.center.lat.toString(),
        "data-lng": _ctx.center.lng.toString(),
        style: _normalizeStyle("background-image: url(".concat(_ctx.cdn, "/_ui/img/placeholders/map_italy_placeholder.webp);"))
      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_13)], 2 /* CLASS */)])]), _ctx.aroundMe ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.currentRadiusKm) + " km ", 1 /* TEXT */)]), _createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
        id: "aroundMeSlider",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _ctx.currentRadius = $event;
        }),
        type: "range",
        min: "1000",
        max: "5000",
        step: "1000",
        "class": _normalizeClass(['position-' + _ctx.currentRadiusKm, "tw-relative tw-mr-20px !tw-w-full"])
      }, null, 2 /* CLASS */), [[_vModelText, _ctx.currentRadius, void 0, {
        number: true
      }]])])])) : _createCommentVNode("v-if", true), _createElementVNode("div", {
        id: "map-actions-container",
        "class": _normalizeClass(["tw-items-center tw-px-10px md:tw-px-0 md:tw-mr-[40px] tw-absolute tw-left-0 tw-right-0 tw-bottom-20px sm:max-sm:tw-bottom-[100px] lg:tw-left-1/3 xl:tw-left-1/4 lg:tw-max-w-[400px] lg:tw-m-auto tw-self-center tw-flex tw-justify-around tw-z-[1050]", {
          'hasPolygon tw-flex tw-justify-around': _ctx.hasPolygon
        }])
      }, [!_ctx.mapDrawing && !_ctx.aroundMe ? (_openBlock(), _createBlock(_component_base_button, {
        id: "start-drawing-btn",
        key: "start-drawing-btn",
        "data-cy": "start-drawing-btn",
        "class": "tw-btn-w-primary",
        onClick: _withModifiers(_ctx.startDrawing, ["stop"])
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.labels.clickToDrawOnMap), 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])) : _createCommentVNode("v-if", true), _ctx.hasPolygon && !_ctx.aroundMe ? (_openBlock(), _createBlock(_component_base_button, {
        id: "delete-polygon-btn",
        key: "delete-polygon-btn",
        "class": "sm:tw-min-w-fit sm:tw-flex-grow-0 tw-mr-20px tw-flex-1 max-md:tw-mr-5px tw-ml-0",
        "btn-class": "tw-btn-w-danger tw-btn-outline tw-btn-md",
        onClick: _ctx.deletePolygon,
        innerHTML: _ctx.labels["delete"]
      }, null, 8 /* PROPS */, ["onClick", "innerHTML"])) : _createCommentVNode("v-if", true), _createCommentVNode(" Draw map "), _ctx.hasPolygon && !_ctx.aroundMe && !_ctx.mapError ? (_openBlock(), _createBlock(_component_base_button, {
        id: "confirm-polygon-btn",
        ref: "confirmMap",
        key: "confirm-polygon-btn",
        "is-loading": _ctx.loading,
        "btn-class": "tw-btn-md tw-btn-w-primary tw-flex-1 tw-ml-5px tw-mr-0",
        onClick: _ctx.confirmPolygon,
        innerHTML: _ctx.labels.confirm
      }, null, 8 /* PROPS */, ["is-loading", "onClick", "innerHTML"])) : _createCommentVNode("v-if", true), _createCommentVNode(" Around me "), _ctx.aroundMe && !_ctx.mapError ? (_openBlock(), _createBlock(_component_base_button, {
        id: "confirm-polygon-aroundme-btn",
        ref: "confirmMapAroundMe",
        key: "confirm-polygon-aroundme-btn",
        "is-loading": _ctx.loading,
        "btn-class": "tw-btn-md tw-btn-w-primary tw-ml-[20px]",
        onClick: _ctx.confirmAndSearchPolygon,
        innerHTML: _ctx.labels.confirm
      }, null, 8 /* PROPS */, ["is-loading", "onClick", "innerHTML"])) : _createCommentVNode("v-if", true)], 2 /* CLASS */)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal", "custom-modal-header-classes", "header-title", "onClosed"]);
}